<app-global-breadcrumbs class="d-none"></app-global-breadcrumbs>
<app-global-inner-banner>My Reports</app-global-inner-banner>
<div class="report-main">
    <section class="section-gap innerpage pageStaticsBgColor">
        <div class="container">
            <mat-card class="wrapperStaticsCotent">
                <div class="note_">
                    <p><sup>*</sup>Note: Report To Date should be grater then one month from <strong>'Report From Date'</strong>, otherwise you will not get the data.</p>
                </div>
                <div class="flightReportForm">
                    <form [formGroup]="reportCorporate">
                        <div class="row">
                            <mat-form-field class="col-md-6" floatLabel="always" appearance="outline" (click)="picker.open()" readonly>
                                <mat-label>Selected Report From Date - Report To Date</mat-label>
                                <mat-date-range-input  [formGroup]="range" [rangePicker]="picker">
                                    <input matStartDate formControlName="reportFromDate" placeholder="Choose Report From Date">
                                    <input matEndDate formControlName="reportToDate" placeholder="Choose Report To Date">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>

                                <mat-error *ngIf="range.controls['reportFromDate'].hasError('matStartDateInvalid')">Invalid start date</mat-error>
                                <mat-error *ngIf="range.controls['reportToDate'].hasError('matEndDateInvalid')">Invalid end date</mat-error>
                            </mat-form-field>
                            <div class="col-md-6">
                                <button mat-raised-button color="primary" (click)="submitReport()">Generate Report</button>&nbsp;&nbsp;
                                <button mat-raised-button color="primary" type="reset" (click)="resetReport()">Reset</button>
                            </div>
                        </div>
                        <!-- <p>Selected range: {{formattedRange | json}}</p> -->
                    </form>
                </div>
            </mat-card>
            <ng-container *ngIf="reportDetails">
                <mat-card class="wrapperStaticsCotent">
                    <div class="titleHeading d-flex justify-content-between align-items-center">
                        <h3>Report Details <span>{{formattedRange?.reportFromDate | date: 'dd MMMM yyyy'}}</span> to <span>{{formattedRange?.reportToDate | date: 'dd MMMM yyyy'}}</span></h3>
                        <button mat-raised-button color="primary" type="reset" (click)="downloadReport()"><mat-icon>download</mat-icon> Download Report</button>
                    </div>
                    <div class="reportTable">
                        <app-mat-table [columns]="columns" [dataSource]="listItem"></app-mat-table> <!-- (rowAction)="rowAction($event)"-->
                    </div>
                </mat-card>
            </ng-container>
        </div>
    </section>
</div>